import script from "./CreateUpdateThresholdRule.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateUpdateThresholdRule.vue?vue&type=script&setup=true&lang=ts"

import "./CreateUpdateThresholdRule.vue?vue&type=style&index=0&id=5af0ff14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af0ff14"]])

export default __exports__